import { Flex, Text } from "@chakra-ui/layout";
import { Skeleton } from "@chakra-ui/skeleton";
import { FaBuilding } from "react-icons/fa";
import CardDefault from "components/Cards/CardDefault";
import colors from "core/resources/theme/colors";

interface Card1HorizontalConciliacaoBancariaProps {
  title: string;
  description: string;
  onClick?: any;
  icon?: any;
  bg: string;
  color: string;
  loading?: boolean;
  right?: any;
  w?: string;
  colorTitle?: string;
}

function Card1HorizontalConciliacaoBancaria({
  title,
  description,
  onClick,
  icon,
  bg,
  color,
  loading,
  right,
  w,
  colorTitle,
}: Card1HorizontalConciliacaoBancariaProps) {
  return (
    <CardDefault
      flexDir="row"
      justifyContent="center"
      alignItems="center"
      onClick={onClick}
      h="100%"
      w={w}
      px={4}
      py={3}
    >
      {loading ? (
        <Flex
          flex={1}
          justifyContent="start"
          alignItems={"start"}
          flexDir={"column"}
          gap="8px"
          h="110px"
        >
          <Skeleton rounded={"full"} h={"50px"} w="50px" />
          <Skeleton h={"15px"} w="150px" />
          <Skeleton h={"30px"} w="70px" />
        </Flex>
      ) : (
        <>
          <Flex flex={1} justifyContent="flex-start" flexDir="column">
            <Flex
              w="50px"
              h="50px"
              rounded="50%"
              justifyContent="center"
              alignItems="center"
              bg={bg}
            >
              {!icon ? <FaBuilding fontSize="18px" color={color} /> : icon}
            </Flex>
            <Text fontSize="15px" fontWeight="500" mt={2} mb={1}>
              {description}
            </Text>
            <Text
              fontSize="22px"
              fontWeight="bold"
              color={colorTitle || colors.black900}
            >
              {title}
            </Text>
          </Flex>
          {right ? (
            <Flex px="16px" alignItems="center" justifyContent="center">
              {right}
            </Flex>
          ) : null}
        </>
      )}
    </CardDefault>
  );
}

export default Card1HorizontalConciliacaoBancaria;
